import { unref, type MaybeRef } from 'vue'
import { messageEditEventBus } from './message-edit-event-bus'

export function useCancelMessageEdit(chatId: MaybeRef<number>) {
  return () => messageEditEventBus.emit(unref(chatId), null)
}
